import React, {useEffect, useState} from "react"
import Header from "../components/layout/Header"
import {useAppDispatch, useAppSelector} from "../hooks/redux"
import {useNavigate, useParams} from "react-router-dom"
import {deleteClient, fetchOrderHistory, getClient, setCurrentPage} from "../store/actions/clientActions"
import {IBreadCrumbs} from "../models"
import ClientDetail from "../components/blocks/ClientDetail/ClientDetail"
import Modal from "../components/blocks/modals/Modal"
import ModalEditClient from "../components/blocks/modals/ModalEditClient/ModalEditClient"
import ModalSuccess from "../components/blocks/modals/ModalSuccess/ModalSuccess"
import Loading from "../components/blocks/Loading/Loading"
import classes from "../components/layout/Layout/Layout.module.scss"
import {getOrderStatuses} from "../store/actions/orderActions"
import Button from "../components/generic/buttons/Button"

function ClientDetailPage() {

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {client, isLoadingClient} = useAppSelector(state => state.client)
  const [modalEditShown, modalEditToggle] = useState(false)
  const [modalDeleteShown, modalDeleteToggle] = useState(false)
  const [modalEditSuccessShown, modalEditSuccessToggle] = useState(false)

  type clientParams = {
    client_uuid: string
  }

  const {client_uuid} = useParams<clientParams>()

  useEffect(() => {
    if (client_uuid) {
      dispatch(getClient({client_uuid}))
      dispatch(fetchOrderHistory(client_uuid))
      dispatch(getOrderStatuses())
    }
  }, [dispatch, client_uuid])

  const breadcrumbs: IBreadCrumbs = (client && client.id) ? {
    backUrl: "/handbook/",
    items: [
      "Справочник",
      client.fio
    ]
  } : {}

  const deleteHandler = async () => {
    const isDeleted = await dispatch(deleteClient(client.client_uuid))

    if (isDeleted) {
      modalDeleteToggle(false)
      await dispatch(setCurrentPage(1))
      navigate('/handbook/')
    }
  }

  const modalEdit = modalEditShown && client &&
    <ModalEditClient
      close={() => modalEditToggle(false)}
      editSuccess={modalEditSuccessToggle}
      editableItem={client}
    />

  const modalEditSuccess = modalEditSuccessShown &&
    <ModalSuccess
      close={() => modalEditSuccessToggle(false)}
      title={"Клиент обновлен!"}
    />

  const modalDelete = modalDeleteShown &&
    <Modal
      title={"Удалить клиента?"}
      close={() => modalDeleteToggle(false)}
      dialogSizeSuffix={"w350"}
      submitClick={deleteHandler}
      submitText={"Да, удалить"}
      cancelClick={() => modalDeleteToggle(false)}
      headerAlignCenter={true}
    />

  const renderError = !client &&
    <div style={{textAlign: "center"}}>
      <p>Клиент не найден!</p>
      <Button onClick={() => navigate(`/handbook/`)}>Перейти к списку клиентов</Button>
    </div>

  return (
    <>
      <div className={classes.header}>
        <Header isLoading={isLoadingClient} breadcrumbs={breadcrumbs} showUser={true}/>
      </div>
      <div className={classes.content}>
        {isLoadingClient && <Loading/>}
        {!isLoadingClient && !client && renderError}
        {!isLoadingClient && client && !!client.id &&
          <ClientDetail
            modalEditToggle={modalEditToggle}
            modalDeleteToggle={modalDeleteToggle}
          />
        }
        {modalEdit}
        {modalEditSuccess}
        {modalDelete}
      </div>
    </>
  )
}

export default ClientDetailPage